import {createSlice}  from "@reduxjs/toolkit"
import {ToastMessage} from "primereact/toast"
// import { ActionType } from "../type";



export interface ToastStateType extends ToastMessage{}

const initialState:ToastStateType={
    severity:undefined,
    summary:undefined,
    detail:undefined
}

export const  toastSlice=createSlice({
    name:"toast",
    initialState,
    reducers:{
        setToast:(state:ToastStateType,action: ReduxActionType<ToastStateType> )=>{
            state.severity=action.payload.severity||"info";
            state.summary=action.payload.summary||undefined;
            state.detail=action.payload.detail||undefined;
        }
    }
})

export const toastReduce= toastSlice.reducer;
export const {setToast} = toastSlice.actions;